import React, { useState, useEffect, useRef, useCallback } from "react";
import "../styles/about.css";
import { Link } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const carouselData = [
  {
    image:
      "https://res.cloudinary.com/dqv3ihfrx/image/upload/v1770543195/TOYOTA_HiLux-2025__main_aiu3se.jpg",
    name: "Toyota Hilux",
    price: "sh. 6,250,000",
  },
  {
    image:
      "https://res.cloudinary.com/dqv3ihfrx/image/upload/v1770543273/toyota-land-cruiser-gallery-14-2_Medium-Landscape_labxvl.webp",
    name: "LANDCRUISER ZX",
    price: "sh. 10,600,000",
  },
  {
    image:
      "https://res.cloudinary.com/dqv3ihfrx/image/upload/v1770543323/2017-mercedes-amg-c63-s-cabriolet_gj5eea.jpg",
    name: "C63S CABRIOLET",
    price: "sh. 9,400,000",
  },
  {
    image:
      "https://res.cloudinary.com/dqv3ihfrx/image/upload/v1770543378/Merc-C180-1_h6amnw.avif",
    name: "Mercedes Benz C180",
    price: "sh. 3,590,000",
  },
  {
    image:
      "https://res.cloudinary.com/dqv3ihfrx/image/upload/v1770543420/IMG-20231029-WA0158_yfhugt.jpg",
    name: "Honda Vezel 1500cc Hybrid",
    price: "sh. 2,650,000",
  },
];

const AboutUsCard = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const intervalRef = useRef(null);

  const resetInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    startInterval();
  };

  const startInterval = useCallback(() => {
    intervalRef.current = setInterval(() => {
      setCurrentSlide((prev) =>
        prev === carouselData.length - 1 ? 0 : prev + 1,
      );
    }, 5000); // Increased interval for better readability
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === carouselData.length - 1 ? 0 : prev + 1,
    );
    resetInterval();
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? carouselData.length - 1 : prev - 1,
    );
    resetInterval();
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    resetInterval();
  };

  useEffect(() => {
    startInterval();
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [startInterval]);

  return (
    <main
      className="about-page"
      style={{ marginTop: "60px" }}
      itemScope
      itemType="https://schema.org/AboutPage"
    >
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "AutoDealer",
            "name": "Classic Motors KE",
            "description": "Leading car dealer in Mombasa Kenya specializing in new, foreign used, and locally used vehicles with 100% delivery record",
            "url": "https://www.classicmotorske.com",
            "logo": "%PUBLIC_URL%/logo.jpg",
            "telephone": "+254707308556",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "",
              "addressLocality": "Mombasa",
              "addressRegion": "Mombasa",
              "postalCode": "",
              "addressCountry": "KE"
            },
            "openingHours": "Mo-Fr 08:00-17:00, Sa 08:00-13:00",
            "priceRange": "$$$",
            "sameAs": [
              "https://www.facebook.com/classicmotorske",
              "https://www.instagram.com/classicmotorske"
            ]
          }
        `}
      </script>

      <section id="about" className="about-wrapper">
        <div className="container">
          <div className="about-grid">
            <div className="about-content">
              <div className="about-badge">1</div>
              <h1 className="about-heading" itemProp="headline">
                Classic Motors KE - Your Trusted Car Dealer in Mombasa
              </h1>
              <p className="about-description" itemProp="description">
                With over a decade of experience in Kenya's automotive industry,
                Classic Motors KE has established itself as a premier
                destination for quality vehicles. We specialize in new, foreign
                used, and locally used cars, offering a 100% delivery record on
                all imports.
              </p>
              <p className="about-description">
                Whether you're looking for a fuel-efficient Toyota for Mombasa's
                roads or a luxury European import, our extensive inventory and
                expert team will help you find the perfect vehicle. We
                understand Kenya's car market intimately and provide tailored
                solutions for both individual and corporate clients.
              </p>
              <div className="about-stats">
                <div className="stat-item">
                  <span className="stat-number">10+</span>
                  <span className="stat-label">Years in Business</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">100%</span>
                  <span className="stat-label">Delivery Record</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Happy Customers</span>
                </div>
              </div>
              <div className="about-cta">
                <Link
                  to="/cars"
                  className="about-button"
                  itemProp="significantLink"
                  aria-label="Browse our car inventory"
                  style={{ marginRight: "2px" }}
                >
                  Explore Our Inventory
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M3.33325 8H12.6666"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 3.33334L12.6667 8.00001L8 12.6667"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>
              </div>
            </div>

            <div className="about-image">
              <div className="carousel-container">
                <div className="carousel-image-wrapper">
                  <img
                    decoding="async"
                    loading="lazy"
                    src={carouselData[currentSlide].image}
                    alt={`${carouselData[currentSlide].name} at Classic Motors KE`}
                    className="about-img"
                    itemProp="image"
                  />
                  <div className="carousel-overlay">
                    <div className="carousel-info-card">
                      <h3 className="carousel-model-name">
                        {carouselData[currentSlide].name}
                      </h3>
                      <div className="carousel-price-info">
                        <span
                          className="carousel-price"
                          style={{ fontSize: "12px" }}
                        >
                          Starting from {carouselData[currentSlide].price}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-controls">
                  <button
                    onClick={prevSlide}
                    aria-label="Previous image"
                    className="carousel-button"
                  >
                    <FaChevronLeft />
                  </button>
                  <div className="carousel-indicators">
                    {carouselData.map((_, index) => (
                      <button
                        key={index}
                        className={`carousel-indicator ${
                          index === currentSlide ? "active" : ""
                        }`}
                        onClick={() => goToSlide(index)}
                        aria-label={`Go to image ${index + 1}`}
                      />
                    ))}
                  </div>
                  <button
                    onClick={nextSlide}
                    aria-label="Next image"
                    className="carousel-button"
                  >
                    <FaChevronRight />
                  </button>
                </div>
              </div>
              <div className="about-image-highlight"></div>
            </div>
          </div>
        </div>

        <div className="about-feature">
          <div className="container">
            <div className="about-grid about-grid-reversed">
              <div className="about-image">
                <div className="carousel-container">
                  <div className="carousel-image-wrapper">
                    <img
                      decoding="async"
                      loading="lazy"
                      src={carouselData[currentSlide].image}
                      alt={`Customer inspecting ${carouselData[currentSlide].name}`}
                      className="about-img"
                      itemProp="image"
                    />
                    <div className="carousel-overlay">
                      <div className="carousel-info-card">
                        <h3 className="carousel-model-name">
                          {carouselData[currentSlide].name}
                        </h3>
                        <div className="carousel-price-info">
                          <span className="carousel-price">
                            {carouselData[currentSlide].price}
                          </span>
                          <span className="carousel-year">
                            {carouselData[currentSlide].year}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="carousel-controls">
                    <button
                      onClick={prevSlide}
                      aria-label="Previous image"
                      className="carousel-button"
                    >
                      <FaChevronLeft />
                    </button>
                    <div className="carousel-indicators">
                      {carouselData.map((_, index) => (
                        <button
                          key={index}
                          className={`carousel-indicator ${
                            index === currentSlide ? "active" : ""
                          }`}
                          onClick={() => goToSlide(index)}
                          aria-label={`Go to image ${index + 1}`}
                        />
                      ))}
                    </div>
                    <button
                      onClick={nextSlide}
                      aria-label="Next image"
                      className="carousel-button"
                    >
                      <FaChevronRight />
                    </button>
                  </div>
                </div>
                <div className="about-image-highlight about-image-highlight-secondary"></div>
              </div>
              <div className="about-content">
                <div className="about-badge about-badge-secondary">2</div>
                <h2 className="about-heading">
                  Why Choose Classic Motors KE in Mombasa?
                </h2>
                <p className="about-description">
                  As one of Mombasa's most reliable car dealers, we offer:
                </p>
                <ul className="about-benefits">
                  <li itemProp="knowsAbout">
                    Transparent pricing with no hidden costs
                  </li>
                  <li itemProp="knowsAbout">
                    Comprehensive vehicle inspections
                  </li>
                  <li itemProp="knowsAbout">Flexible financing options</li>
                  <li itemProp="knowsAbout">Professional import services</li>
                  <li itemProp="knowsAbout">
                    After-sales support and warranty options
                  </li>
                </ul>
                <p className="about-description">
                  Our team of automotive experts has in-depth knowledge of
                  Kenya's car market, helping you navigate taxes, import
                  regulations, and vehicle maintenance requirements specific to
                  our region.
                </p>
                <div className="about-cta">
                  <Link
                    to="/contact"
                    className="about-button about-button-secondary"
                    aria-label="Visit our Mombasa showroom"
                  >
                    Visit Our Showroom
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M3.33325 8H12.6666"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8 3.33334L12.6667 8.00001L8 12.6667"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AboutUsCard;
